
import { supabase } from '@/integrations/supabase/client';

export const checkBookingConflict = async (
  shopName: string, 
  date: string, 
  time: string
): Promise<boolean> => {
  try {
    const { data, error } = await supabase
      .from('New Bookings')
      .select('id')
      .eq('Shop Name', shopName)
      .eq('Date', date)
      .eq('Time', time)
      .limit(1);

    if (error) {
      console.error('Error checking booking conflict:', error);
      return false;
    }

    return data && data.length > 0;
  } catch (error) {
    console.error('Error checking booking conflict:', error);
    return false;
  }
};

export const getBookedTimeSlots = async (
  shopName: string, 
  date: string
): Promise<string[]> => {
  try {
    const { data, error } = await supabase
      .from('New Bookings')
      .select('Time')
      .eq('Shop Name', shopName)
      .eq('Date', date);

    if (error) {
      console.error('Error fetching booked time slots:', error);
      return [];
    }

    return data ? data.map(booking => booking.Time).filter(Boolean) : [];
  } catch (error) {
    console.error('Error fetching booked time slots:', error);
    return [];
  }
};
